import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, RouterLink} from '@angular/router';
import {
  AbstractControl,
  FormControl,
  FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn,
  Validators
} from '@angular/forms';
import {ChangePasswordService} from 'src/app/services/change_password_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { MatFormField, MatLabel, MatError } from "@angular/material/select";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'change-password',
    templateUrl: './change_password.component.html',
    styleUrls: ['./change_password.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatError, MatProgressBar, MatProgressSpinner, MatFormFieldModule, MatButtonModule, MatInputModule, RouterLink]
})
export class ChangePasswordComponent implements OnInit {

    changePasswordForm = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)]),
        confirmPassword: new FormControl(''),
    });

    get formControls(): { [p: string]: AbstractControl } {
        return this.changePasswordForm.controls;
    }

    loading = false;
    saving = false;
    error = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private changePasswordService: ChangePasswordService,
    private tokenStorage: TokenStorageService,
  ) {
  }

  ngOnInit(): void {
    this.tokenStorage.clearToken();
    this.changePasswordForm.setValidators(this.samePasswords(this.changePasswordForm));
    this.changePasswordForm.controls.confirmPassword.setValidators([Validators.required, this.samePasswords(this.changePasswordForm)]);
  }

  samePasswords(formGroup: FormGroup): ValidatorFn {
        return (): ValidationErrors | null => {
            const password = formGroup.controls.password;
            const confirmPassword = formGroup.controls.confirmPassword;

            return password.value !== confirmPassword.value &&
                (password.dirty && confirmPassword.dirty) &&
                (password.value !== '' && confirmPassword.value !== '')
                    ? {notSame: true}
                    : null;
        };
  }

  onSubmit(): void {
    const changePasswordId = this.activatedRoute.snapshot.paramMap.get('id');

    if (changePasswordId != null) {
      this.saving = true;

      const password = this.formControls.password.value;

      this.changePasswordService.post([], {changePasswordId, password}).subscribe(
        _ => {
          this.saving = false;
          this.router.navigate(['login']);
        },
        (error) => {
          this.saving = false;
          this.error = error;
        }
      );
    } else {
      this.error = 'Invalid change request, try sending another link to your email.';
    }
  }
}
